export var StateSync;
(function (StateSync) {
    StateSync["SIGNOUT"] = "syncSignout";
    StateSync["EXPIRATION"] = "syncExpiration";
})(StateSync || (StateSync = {}));
//# sourceMappingURL=StateSync.js.map